import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'

const Services = function () {
  return (
    <AbstractCollection
      collectionName="Services"
      singleCollectionName="Service"
      notToShow={[
        'ancestorIds',
        'parentId',
        'videos',
        'type',
        'createdAt',
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      toShow={['name', 'coverPhoto', 'status', 'featured', 'createdAt']}
      type={typeConstant.SERVICES}
    />
  )
}
export default Services
